import { Text, Box, HStack, BoxProps } from '@chakra-ui/react';
import { isSameDay } from 'date-fns';

import { weekLabel, monthLabel } from '~/types/utilities';

type PickupDaySelectProps = {
  dayList: Array<Date>;
  date: Date | null;
  onChangeDate: (date: Date) => void;
};

// 選擇特定日期 一星期
export default function PickupDaySelect({ dayList, date, onChangeDate }: PickupDaySelectProps) {
  const handleActiveStyle = (isActive: boolean): BoxProps => {
    return isActive
      ? {
          bgColor: 'primary',
          color: 'white',
          borderColor: 'primary',
        }
      : {
          bgColor: 'white',
          color: 'fontColor',
          borderColor: 'gray.300',
        };
  };

  return (
    <HStack align="flex-start" spacing={2} py={2}>
      {dayList.map((value) => {
        return (
          <Box
            key={value.toString()}
            as="button"
            borderRadius="5px"
            p={2}
            flex="1"
            border="1px solid"
            onClick={() => onChangeDate(value)}
            {...handleActiveStyle(!!date && isSameDay(date, value))}
          >
            <Text color="inherit" fontSize="xs">
              週{weekLabel[value.getDay()].label}
            </Text>
            <Text color="inherit" fontSize="lg" fontWeight="bold">
              {value.getDate()}
            </Text>
            <Text color="inherit" fontSize="xs">
              {monthLabel[value.getMonth()]}月
            </Text>
          </Box>
        );
      })}
    </HStack>
  );
}
